import { useEffect, useState } from "react";
import DiamondGame from "./diamondGame";
import BatMonster from "../assets/bat-monster.PNG"
import attackSlash from "../assets/attackSlashUnderale_loop_once_0.65x.gif"

// const queryPrefix = "/api"

const appScriptApi = process.env.REACT_APP_APP_SCRIPT_URL

const Home = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true)
    const [number, setNumber] = useState(null);
    const [previousNumber, setPreviousNumber] = useState(null);
    const [hoursTillRefresh, setHoursTillRefresh] = useState(null);
    const [sharePressedText, setSharePressedText] = useState(null);
    const [playAnimation, setPlayAnimation] = useState(false);

    useEffect(() => {
        // getImportantInfo()
        getImportantInfoFromAppScript();
        // gamePlayUpdateAppScript();
    }, [])

    // const getImportantInfo = async () => {
    //     const userId = localStorage.getItem("userId");
    //     let queryString  = queryPrefix + "/api/general/get-important-info"
    //     if(userId) {
    //         const params = new URLSearchParams({
    //             userId: userId,
    //         });
    //         queryString += `?${params.toString()}`
    //     } 
    //     const response = await fetch(queryString);
    //     if (response.ok) {
    //         const json = await response.json()
    //         localStorage.setItem("userId", json.user.userId)
    //         setUser(json.user)
    //         setNumber(json.number)
    //         setHoursTillRefresh(json.hoursTillRefresh);
    //         setPreviousNumber(json.previousNumber)
    //     }
    //     setLoading(false)
    // }

    const getImportantInfoFromAppScript = async () => {
        const userId = localStorage.getItem("userId");
        let queryString  = appScriptApi
        if(userId) {
            const params = new URLSearchParams({
                userId: userId,
            });
            queryString += `?${params.toString()}`
        } 
        const response = await fetch(queryString);
        if (response.ok) {
            const json = await response.json()
            localStorage.setItem("userId", json.user.userId)
            setUser(json.user)
            setNumber(json.number)
            setHoursTillRefresh(json.hoursTillRefresh);
            setPreviousNumber(json.previousNumber)
        }
        setLoading(false)
    }

    // const gamePlayedUpdateDatabase = async (damage, position) => {
    //     setLoading(true)
    //     const userId = localStorage.getItem("userId")
    //     if (userId) {
    //         const response = await fetch(queryPrefix + "/api/user/decrement-number", {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify({ userId: userId, damage: damage, position: position })
    //         });
    //         if (response.ok) {
    //             const json = await response.json();
    //             setNumber(json.number)
    //             setUser(json.user)
    //         }
    //     }
    //     setLoading(false)
    // }

    const gamePlayUpdateAppScript = async (damage, position) => {
        setLoading(true)
        const userId = localStorage.getItem("userId")
        if (userId) {
            const response = await fetch(appScriptApi, {
                method: 'POST',
                body: JSON.stringify({ userId: userId, damage: damage, position: position })
            });
            if (response.ok) {
                const json = await response.json();
                setNumber(json.number)
                setUser(json.user)
            }
        }
        setLoading(false)
    }

    const handleShare = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobileDevice = /android|iphone|ipad|ipod|windows phone/i.test(userAgent.toLowerCase());
        const text = `you dealt: ${user.damageDelt} points of damage\nHealth Remaining: ${number}\nplease help us slay the beast\nhttps://together-stronger-production.up.railway.app`
        if(!isMobileDevice) {
            setSharePressedText("text copied to clipboard")
            navigator.clipboard.writeText(text);
        }
        else if(navigator.share) {
            navigator.share({
                text: text,
                title: 'together stronger',
            })
        }
    } 

    // if (loading) {
    //     return (
    //         <div className="container">
    //             <h2 id="heading">Together Stronger</h2>
    //             <h3 className="loading-screen">
    //                 loading...
    //             </h3>
    //         </div>
    //     )
    // }

    return (
        <div className="container">
            <h2 id="heading">Together Stronger</h2>
            <div className="content">
                <div className="header-message">
                    Help! Save us from the monster
                </div>
                <p className="the-number">hp: {number}</p>
                <p className="the-number">damage delt today: {previousNumber-number}</p>
                <div className="monster">
                    <img src={BatMonster} alt="bat-monster" className="monster-image"/>
                    {playAnimation && <div className="slash-gif-parent"><img src={attackSlash} alt="bat-monster" className="slash-gif"/></div>}
                </div>
                {<DiamondGame 
                    gamePlayedUpdateDatabase={gamePlayUpdateAppScript}
                    user={user}
                    loading={loading}
                    setPlayAnimation={setPlayAnimation}
                />}
                {!loading && user && user.hasPressedToday && <div style={{color: "white", paddingTop: "30px"}}>
                    <div>Wow! you did <b><u>{user.damageDelt} points</u></b> of damage but it seems like your weapon has broken</div>
                    <div>we will get you another weapon in <b><u>{hoursTillRefresh} hours</u></b> so please come back again to help defeat the monster</div>
                    <div>
                        In the meantime,
                        <span className="share" onClick={handleShare}>Share</span>
                        your achievement with others and encourage them to help save the world.
                    </div>
                    
                    <p><b><u>{sharePressedText}</u></b></p>

                </div>
                }
            </div>
        </div>
    );
}

export default Home;